/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.pagetopControll = function () {
    let target = $('.c-pagetop');
    let point;
    let windowHeight;
    let offset;

    function scroll() {
      point = $('.l-footer').offset().top;
      windowHeight = window.innerHeight;
      offset = window.pageYOffset + windowHeight;
      window.requestAnimationFrame(function () {
        // pagetopの表示開始
        if (window.pageYOffset >= windowHeight) {
          target.fadeIn();
        } else {
          target.fadeOut();
        }

        // pagetopの色を変更する
        if (offset >= point) {
          target.addClass('is-color-white');
        } else {
          target.removeClass('is-color-white');
        }
      });
    }

    document.addEventListener('scroll', scroll, {passive: true});
  };

  $(function () {
    var app = new growApp();
    app.pagetopControll();
  });
})(jQuery);
